<template>
  <div class="list_type_index_page">
    <job-header-simple :header_title="currentModule.name"></job-header-simple>
    <div class="public_empty_section message" v-if="list.length == 0"></div>
    <div class="header">
      <p class="title">{{ currentModule.name }}</p>
      <p>{{ currentModule.remark }}</p>
    </div>

    <van-list
      v-model="loading"
      :finished="finished"
      finished-text="没有更多了"
      @load="initList"
      :error.sync="error"
      error-text="请求失败，点击重新加载"
    >
      <van-panel
        v-for="(item, index) in list"
        :key="index"
        class="list"
        @click="handleClick(item.id)"
      >
        <div slot="header" class="list-header van-hairline--bottom">
          <p class="van-ellipsis">{{item.title}}</p>
          <span>{{item.createDate}}</span>
        </div>
        <div class="list-content">
          <div v-html="item.remark"></div>
        </div>
        <div slot="footer">
          <div class="list-footer van-ellipsis">{{ item.company }}</div>
        </div>
      </van-panel>
    </van-list>
  </div>
</template>
<script>
import api from "@/api/list";
import { Notify, List } from "vant";
import { Panel } from "vant";
import jobHeaderSimple from "@/components/header/header.vue";
export default {
  components: {
    [Panel.name]: Panel,
    jobHeaderSimple,
    [Notify.name]: Notify,
    [List.name]: List
  },
  data() {
    return {
      error: false,
      loading: false,
      finished: false,
      currentModule: {},
      list: [],
      page: {
        current: 0,
        size: 10
      }
    };
  },
  created() {
    this.initModule();
  },
  methods: {
    initModule() {
      let id = this.$route.query.id;
      if (id && typeof id != "undefined") {
        api.contentModulelistToActiveUser({ id: id }).then(res => {
          if (res.data.status == "200") {
            this.currentModule = res.data.data[0];
          }
        });
      }
    },
    initList() {
      let param = {};
      param.current = this.page.current + 1;
      param.size = this.page.size;
      api
        .contentArticlelistToActiveUser(param, {
          subUrl: this.$route.params.code
        })
        .then(res => {
          // 加载状态结束
          this.loading = false;
          if (res.data.status == "200") {
            this.page.current = res.data.data.current;
            this.page.size = res.data.data.size;
            this.list = this.list.concat(res.data.data.records);
            if (res.data.data.records.length < this.page.size) {
              this.finished = true;
            }
          } else {
            this.error = true;
            this.$notify({
              message: res.data.message,
              type: "danger",
              duration: 2000
            });
          }
        });
    },
    handleClick(id) {
      this.$router.push({
        path: "/article/details",
        query: {
          id: id
        }
      });
    }
  }
};
</script>

<style lang="less" scoped>
.header {
  background: @blue;
  color: #fff;
  padding: 12px;
  font-size: 12px;
  p.title {
    text-align: center;
    font-size: 16px;
    line-height: 30px;
  }
}
.list {
  margin: 12px;
  .list-header {
    padding: 12px;
    font-size: 14px;
    p {
      display: inline-block;
      width: 70%;
      color: #333;
    }

    span {
      color: #999;
      float: right;
    }
  }
  .list-content {
    padding: 12px 15px;
    color: #666;
    font-size: 12px;
    line-height: 20px;

    div {
      position: relative;
      max-height: 120px;
      overflow: hidden;
    }
  }

  .list-footer {
    color: #666;
    font-size: 12px;
  }

  /deep/ .van-panel__header-value {
    color: #999;
  }
}
</style>